import React, { useEffect, useState } from 'react'
import { IonButton, IonIcon } from '@ionic/react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
	checkmarkOutline,
	copyOutline,
} from 'ionicons/icons'

type CopyButtonProps = {
	text: string
    label?: string
    title?: string
	className?: string
}

const CopyButton = (props: React.PropsWithChildren<CopyButtonProps>) => {

	const [ copied, setCopied ] = useState(false)

	useEffect(() => {
		if (!copied)
			return

		const timeout = window.setTimeout(() => setCopied(false), 1500)

		return () => window.clearTimeout(timeout)
	}, [ copied ])

	return (
		<CopyToClipboard
			text={props.text}
			onCopy={(_text, result) => setCopied(result)}
		>
			<IonButton
				className={props.className}
				fill="clear"
				size="small"
				title={props.title}
			>
				<IonIcon
					icon={copied ? checkmarkOutline : copyOutline}
					slot="start"
				/>
				{props.children || props.label || null}
			</IonButton>
		</CopyToClipboard>
	)
}

export default CopyButton
